import script from "./search.vue?vue&type=script&setup=true&lang=ts"
export * from "./search.vue?vue&type=script&setup=true&lang=ts"

import "./search.vue?vue&type=style&index=0&id=7014a114&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Projects/IceCreamSearch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7014a114"]])

export default __exports__